import { create } from "zustand";

const useFlowStore = create((set) => ({
  flow: null,
  setFlow: (flow) => set(() => ({ flow })),
  activeTemplate: "",
  setActiveTemplate: (activeTemplate) => set(() => ({ activeTemplate })),
  flowTemplates: [],
  setFlowTemplates: (templates) => set(() => ({ flowTemplates: templates })),
  selectedVersions: {},
  setSelectedVersion: (flowId, version) => {
    console.log("Setting selected version for flow", flowId, version);
    set((state) => ({
      selectedVersions: { ...state.selectedVersions, [flowId]: version },
    }));
  },
}));

export default useFlowStore;
